import { SyntheticEvent } from 'react';

export const classNames = (list: (string | false | undefined)[]): string => {
  return list.filter(Boolean).join(' ');
};

export const isHTMLElement = (val: unknown): val is HTMLElement => {
  return val instanceof HTMLElement;
};

export const isElement = (val: unknown): val is Element => {
  return val instanceof Element;
};

export const preventEvent = (event: SyntheticEvent): void => {
  event.preventDefault();
  event.stopPropagation();
};

export const isWindows = (): boolean => /Windows/i.test(navigator.userAgent);
export const isMacOS = (): boolean => /Mac OS/i.test(navigator.userAgent);
export const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const removeProtocol = (url: string): string => {
  return url.replace(/^((.*)\/\/)/, '');
};

export const a11yFocus = (node?: HTMLElement): void => {
  if (isHTMLElement(node)) {
    node.focus();
  }
};

type M = HTMLElementTagNameMap;

export const createNode = <T extends keyof M>(tagName: T, props: Partial<M[T]>): M[T] => {
  return Object.assign<M[T], Partial<M[T]>>(document.createElement<T>(tagName), props);
};

export const getPollingInterval = (test: boolean, userId?: string): number => {
  if (test) {
    return 1500;
  }
  if (userId) {
    return 15000;
  }
  return 10000;
};

export const sleep = (ms: number) => new Promise((res) => setTimeout(res, ms));

export const noop = (): void => void 0;

export const getArticleUriFromLink = (href: string): string | undefined => {
  const oldHelpCenterArticleRegexp = /^https:\/\/support.wix.com\/.*[article|kb]\/([^\s"'?&#]+).*/u;
  return href.match(oldHelpCenterArticleRegexp)?.[1];
};

export const getCategoryUriFromLink = (href: string): string | undefined => {
  // Help Center Static Urls
  const staticHcUrls = [
    '/articles/',
    '/kb/',
    '/hc/',
    '/categories/',
    '/contact',
    '/submit-a-ticket',
    '/forum',
    '/top-questions',
    '/ticket-rate-reply',
    '/search',
    '/ticket/',
    '/ugc/',
    '/tickets',
    '/user/',
    '/settings',
  ];
  const oldHelpCenterCategoryRegexp = /^https:\/\/support.wix.com\/.*?(\/[\p{L}0-9_-]*)/u;
  const maybeUri = href.match(oldHelpCenterCategoryRegexp)?.[1];
  if (maybeUri && !staticHcUrls.find((url) => maybeUri.startsWith(url))) {
    return maybeUri;
  }
  return undefined;
};
